module.exports = __webpack_public_path__ + "img/chevron_up.4ef8d0be.svg";